// extracted by mini-css-extract-plugin
export default {"cont__about":"aboutStyle_cont__about__FS0uv","cont__about_descr":"aboutStyle_cont__about_descr__0zcUV","cont__about_inside":"aboutStyle_cont__about_inside__mpUUN"};